// Welcome — landing/intro. Plain English promise + 4-step explainer.
// Ported from the design's welcome.jsx with ES module imports.
import { PALETTE } from '../palette.js';
import { Button, Pill } from '../components/primitives.jsx';
import { IconLightning, IconSpark } from '../components/icons.jsx';

export default function Welcome({ navigate }) {
  return (
    <div style={{
      flex: 1, background: PALETTE.bg, overflow: 'auto',
      fontFamily: 'Inter, sans-serif', color: PALETTE.ink, height: '100vh',
    }}>
      <div style={{
        height: 56, padding: '0 32px', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', borderBottom: `1px solid ${PALETTE.lineSoft}`,
      }}>
        <div style={{ fontSize: 13, color: PALETTE.ink3 }}>Welcome</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, color: PALETTE.ink3 }}>
          <span>Questions? Call</span>
          <span style={{ color: PALETTE.ink, fontWeight: 500 }}>(613) 555-0102</span>
        </div>
      </div>

      <div style={{ maxWidth: 880, margin: '0 auto', padding: '72px 40px 40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
          <Pill tone="accent"><IconLightning size={11} /> Campaign workspace</Pill>
          <Pill tone="neutral">Curated Meta ads</Pill>
        </div>

        <h1 style={{
          fontFamily: 'Instrument Serif, serif', fontWeight: 400,
          fontSize: 82, lineHeight: 0.98, letterSpacing: '-0.02em',
          margin: '0 0 24px', color: PALETTE.ink,
        }}>
          Keep every campaign<br/>
          <em style={{ fontStyle: 'italic', color: PALETTE.accent }}>clearly in view.</em>
        </h1>

        <p style={{ fontSize: 18, lineHeight: 1.5, color: PALETTE.ink2, maxWidth: 620, margin: '0 0 40px' }}>
          Review existing campaign activity, leads, and company settings from one place.
          New custom lead sites are reserved for a future product release.
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 56 }}>
          <Button variant="accent" size="lg" onClick={() => navigate('campaigns')}>
            <IconSpark size={16} /> Open campaigns
          </Button>
        </div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 0,
          background: PALETTE.surface, border: `1px solid ${PALETTE.line}`, borderRadius: 16,
          overflow: 'hidden',
        }}>
          {[
            { n: '01', t: 'Review', d: 'See saved campaigns and their current delivery state.' },
            { n: '02', t: 'Monitor', d: 'Keep campaign performance and lead activity together.' },
            { n: '03', t: 'Manage', d: 'Maintain company and Meta connection settings safely.' },
            { n: '04', t: 'Get support', d: 'Contact your success manager when an account needs help.' },
          ].map((s, i) => (
            <div key={i} style={{
              padding: '28px 24px',
              borderRight: i < 3 ? `1px solid ${PALETTE.lineSoft}` : 'none',
            }}>
              <div style={{
                fontFamily: 'JetBrains Mono, monospace', fontSize: 11,
                color: PALETTE.accent, letterSpacing: '0.1em', marginBottom: 14,
              }}>{s.n}</div>
              <div style={{ fontSize: 17, fontWeight: 500, marginBottom: 6, letterSpacing: '-0.01em' }}>{s.t}</div>
              <div style={{ fontSize: 13, color: PALETTE.ink2, lineHeight: 1.5 }}>{s.d}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 32, fontSize: 12.5, color: PALETTE.ink3, textAlign: 'center' }}>
          Custom lead-site creation is not available in the current product.
        </div>
      </div>
    </div>
  );
}
